module.exports = __webpack_public_path__ + "img/w1.2dcc5e92.webp";